<template>
  <div
    class="bg-white p-4 rounded-xl border border-gray-300 mx-4 mt-4 calendar-main-container shadow-sm"
  >
    <a-row :gutter="[16, 16]" class="calendar-row">
      <a-col :xs="24" :lg="20" :xl="20" class="calendar-col">
        <template v-if="showAvailableSlotsText">
          <p class="text-sm text-gray-500 mb-4 font-bold">
            {{ availableSlotsText }}
          </p>
        </template>
        <FullCalendar
          v-if="calendarReady"
          :options="calendarOptions"
          class="calendar-content"
        />
      </a-col>
      <a-col :xs="24" :lg="4" :xl="4" class="sidebar-col">
        <div class="sidebar-scroll">
          <a-collapse v-model="activeKey" ghost expand-icon-position="right">
            <a-collapse-panel key="1" class="custom-panel" :showArrow="false">
              <span slot="header" class="text-[#2F3E4C] font-bold">
                {{ "Pendiente por agendar (" + pendingToSchedule.length + ")" }}
              </span>
              <a-icon
                slot="extra"
                type="caret-up"
                class="text-[#2F3E4C] text-lg"
                :rotate="activeKey.indexOf('1') !== -1 ? 0 : 180"
              />
              <p class="text-xs text-gray-500 mb-4">
                Selecciona la sesión pendiente por agendar para observar los
                espacios de sesión recomendados
              </p>
              <div class="flex flex-col gap-3">
                <a-card
                  v-for="(session, index) in pendingToSchedule"
                  :key="'pending-' + index"
                  class="session-card"
                  :class="{
                    'selected-card': selectedSessionId === 'pending-' + index,
                  }"
                  @click="handleSessionClick('pending-' + index, session)"
                >
                  <div class="flex justify-between items-start mb-2">
                    <span class="font-bold text-sm">{{
                      session.codigo_queja
                    }}</span>
                    <a-icon
                      v-if="selectedSessionId === 'pending-' + index"
                      type="close-circle"
                      class="text-gray-400"
                    />
                  </div>
                  <div class="text-[10px] text-gray-600">
                    <p class="font-bold">Consumidor financiero</p>
                    <p>
                      {{
                        session.cf && session.cf.nombre_completo
                          ? session.cf.nombre_completo
                          : ""
                      }}
                    </p>
                    <p>
                      {{
                        session.cf && session.cf.correo_electronico
                          ? session.cf.correo_electronico
                          : ""
                      }}
                    </p>

                    <p class="font-bold mt-3">Entidad vigilada</p>
                    <p>
                      {{
                        session.ev && session.ev.razon_social
                          ? session.ev.razon_social
                          : ""
                      }}
                    </p>
                    <p>
                      {{
                        session.ev && session.ev.correo_electronico
                          ? session.ev.correo_electronico
                          : ""
                      }}
                    </p>
                  </div>
                </a-card>
              </div>
            </a-collapse-panel>

            <a-collapse-panel
              key="2"
              class="custom-panel mt-4"
              :showArrow="false"
            >
              <span slot="header" class="text-[#2F3E4C] font-bold">
                {{
                  "Pendiente por atender solicitud de reprogramación (" +
                  pendingToReschedule.length +
                  ")"
                }}
              </span>
              <a-icon
                slot="extra"
                type="caret-up"
                class="text-[#2F3E4C] text-lg"
                :rotate="activeKey.indexOf('2') !== -1 ? 0 : 180"
              />
              <p class="text-xs text-gray-500 mb-4">
                Selecciona la sesión Pendiente por atender solicitud de
                reprogramación para observar los espacios de sesión recomendados
              </p>
              <div class="flex flex-col gap-3">
                <a-card
                  v-for="(session, index) in pendingToReschedule"
                  :key="'reschedule-' + index"
                  class="session-card"
                  :class="{
                    'selected-card':
                      selectedSessionId === 'reschedule-' + index,
                  }"
                  @click="handleSessionClick('reschedule-' + index, session)"
                >
                  <div class="flex justify-between items-start mb-2">
                    <span class="font-bold text-sm">{{
                      session.codigo_queja
                    }}</span>
                    <a-icon
                      v-if="selectedSessionId === 'reschedule-' + index"
                      type="close-circle"
                      class="text-gray-400"
                    />
                  </div>
                  <div class="text-[10px] text-gray-600">
                    <p class="font-bold mb-1">Consumidor financiero</p>
                    <p>{{ session.nameCf }}</p>
                    <p>{{ session.cf ? session.cf.email : "" }}</p>

                    <p class="font-bold mt-2 mb-1">Entidad vigilada</p>
                    <p>{{ session.nameEv }}</p>
                    <p>{{ session.ev ? session.ev.email : "" }}</p>
                  </div>
                </a-card>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-col>
    </a-row>

    <!-- Modal de detalle de sesión -->
    <SessionDetailModal
      :visible="isModalVisible"
      :session-data="selectedSessionData"
      @close="closeModal"
      @access="handleAccessSession"
      @goToComplaintDetail="handleGoToComplaintDetail"
      @reschedule="handleRescheduleSession"
      @schedule="handleScheduleSession($event)"
    />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import SessionDetailModal from "./SessionDetailModal.vue";
import complaintsAgilizaServicesImplementation from "@/feature/dashboard/complaints_agiliza/data/services/complaints_agiliza_services_impl";
import {
  SFC_COLOR_AZUL,
  SFC_COLOR_NARANJA,
  SFC_COLOR_VERDE,
  SFC_COLOR_VERDE_CLARO,
  STATE_SESION_CHAT_AGENDADA,
  STATE_SESION_FINALIZADA,
  STATE_SESION_FINALIZADA_SIN_GESTION,
  STATE_SESION_PENDIENTE_AGENDAR,
  STATE_SESION_PENDIENTE_ATENDER_REPROGRAMACION,
} from "@/core/utils/constants";

import ErrorMessaje from "@/core/error/error_messaje";

export default {
  name: "SessionsCalendar",
  components: {
    FullCalendar,
    SessionDetailModal,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    externalSelectedSession: {
      type: Object,
      default: () => null,
    },
  },
  async created() {
    this.roleFacilitatorDbId = process.env.VUE_APP_ROLE_FACILITATOR_DB_ID;
    await this.getWorkingHoursForFacilitators(this.roleFacilitatorDbId);
  },
  data() {
    return {
      activeKey: ["1", "2"],
      calendarOptions: {
        height: "auto",
        contentHeight: "auto",
        expandRows: false,
        events: [],
        eventClick: this.handleEventClick,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        // Desactiva la fuente de iconos embebida como data URI (fcicons), ya que
        // queda bloqueada por la directiva font-src del CSP en los entornos desplegados.
        buttonIcons: false,
        buttonText: {
          prev: "<",
          next: ">",
          today: "Hoy",
        },
        initialView: "timeGridWeek",
        locale: esLocale,
        nowIndicator: true,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        slotLabelFormat: {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
          meridiem: "short",
        },
        eventTimeFormat: {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
          meridiem: "short",
        },
        weekends: false,
        slotMinTime: "06:00:00",
        slotMaxTime: "20:00:00",
      },
      roleFacilitatorDbId: null,
      selectedSessionId: null,
      isModalVisible: false,
      selectedSessionData: {},
      availableSlotEvents: [],
      showAvailableSlotsText: false,
      availableSlotsText: "",
      calendarReady: true,
    };
  },
  watch: {
    events: {
      handler(newEvents) {
        this.calendarOptions.events = this.formatEvents(
          newEvents.filter((s) => s.session_date_original),
        );
      },
      immediate: true,
      deep: true,
    },
    externalSelectedSession: {
      handler(newSession) {
        if (newSession) {
          this.handleExternalSelection(newSession);
        }
      },
      immediate: true,
    },
  },
  computed: {
    pendingToSchedule() {
      // Filtrar sesiones que NO tienen fecha original asignada (Pendiente por agendar)
      return this.events.filter(
        (session) =>
          session.session_state_name === STATE_SESION_PENDIENTE_AGENDAR,
      );
    },
    pendingToReschedule() {
      // Filtrar sesiones con solicitud de reprogramación (pueden o no tener fecha, pero se prioriza el flag)
      return this.events.filter(
        (session) =>
          session.session_state_name ===
          STATE_SESION_PENDIENTE_ATENDER_REPROGRAMACION,
      );
    },
  },
  methods: {
    addOneHourToTime(timeString) {
      const [hours, minutes, seconds] = timeString.split(":");
      const date = new Date(
        0,
        0,
        0,
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds),
      );
      date.setHours(date.getHours() + 1);
      return `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes(),
      ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
    },
    formatEvents(sessions) {
      return sessions
        .map((session) => {
          if (
            session.session_state_name === STATE_SESION_CHAT_AGENDADA ||
            session.session_state_name === STATE_SESION_FINALIZADA ||
            session.session_state_name === STATE_SESION_FINALIZADA_SIN_GESTION
          ) {
            // Combinamos la fecha original con las horas de inicio y fin
            const start = `${session.session_date_original}T${session.session_start_time}`;
            const end = `${session.session_date_original}T${session.session_end_time}`;

            let colorSession = null;
            switch (session.session_state_name) {
              case STATE_SESION_CHAT_AGENDADA:
                colorSession = SFC_COLOR_AZUL;
                break;

              case STATE_SESION_FINALIZADA:
                colorSession = SFC_COLOR_VERDE;
                break;

              case STATE_SESION_FINALIZADA_SIN_GESTION:
                colorSession = SFC_COLOR_NARANJA;
                break;

              default:
                break;
            }

            return {
              id: session.id,
              title: `${session.codigo_queja} - Sesión de mediación`,
              start: start,
              end: end,
              backgroundColor: colorSession,
              borderColor: colorSession,
              extendedProps: {
                ...session,
              },
            };
          }
          return null;
        })
        .filter((event) => event !== null);
    },
    handleGoToComplaintDetail(record) {
      this.$router.push(
        `/dashboard/complaint/details?complaint_id=${record.codigo_queja}&type=agiliza`,
      );
    },

    async getWorkingHoursForFacilitators(roleFacilitatorDbId) {
      try {
        const response =
          await complaintsAgilizaServicesImplementation.getWorkingHoursForFacilitators(
            roleFacilitatorDbId,
          );

        if (response.isSuccess && response.data && response.data.data) {
          this.calendarOptions.slotMinTime =
            response.data.data.start_time_morning;
          this.calendarOptions.slotMaxTime = this.addOneHourToTime(
            response.data.data.end_time_afternoon,
          );
        } else {
          this.showToast("error", ErrorMessaje.generalError);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      }
    },
    handleEventClick(info) {
      this.selectedSessionData = info.event.extendedProps;
      this.isModalVisible = true;
      this.$emit("eventClick", info.event);
    },
    async handleSessionClick(uniqueKey, session) {
      const data = this.getWeekRange();

      if (this.selectedSessionId === uniqueKey) {
        // Deseleccionar: remover slots del calendario
        this.showAvailableSlotsText = false;
        this.availableSlotsText = "";
        this.selectedSessionId = null;
        this.availableSlotEvents = [];
        this.calendarOptions.events = this.formatEvents(
          this.events.filter((s) => s.session_date_original),
        );
      } else {
        // Seleccionar: cargar y mostrar slots disponibles
        this.selectedSessionId = uniqueKey;

        try {
          const response =
            await complaintsAgilizaServicesImplementation.getAvailableSpacesAgiliza(
              session.session_agiliza_id,
              data,
            );

          if (response.isSuccess) {
            // Formatear los slots disponibles como eventos
            const slots =
              response.data.data?.available_session_slots ||
              response.data?.available_session_slots ||
              [];

            this.availableSlotEvents = this.formatAvailableSlots(
              slots,
              session,
            );

            const weekRange = this.getWeekRangeFormatted();
            this.showAvailableSlotsText = true;
            this.availableSlotsText = `Se dispone de ${this.availableSlotEvents.length} espacio(s) disponible(s) entre ${weekRange.start_date} y ${weekRange.end_date} para agendar la sesión de la queja con código: ${session.codigo_queja} y con estado: ${session.session_state_name}.`;

            // Combinar eventos originales + slots disponibles
            const originalEvents = this.formatEvents(
              this.events.filter((s) => s.session_date_original),
            );
            this.calendarOptions.events = [
              ...originalEvents,
              ...this.availableSlotEvents,
            ];
          } else {
            this.showToast("error", ErrorMessaje.generalError);
          }
        } catch (error) {
          this.showToast("error", ErrorMessaje.internalServerError);
        }
      }
    },

    formatAvailableSlots(slots, session) {
      return slots.map((slot, index) => {
        const start = `${slot.session_date}T${slot.session_start_time}`;
        const end = `${slot.session_date}T${slot.session_end_time}`;

        // session.session_date_original = slot.session_date;

        return {
          id: session.id,
          title: "Espacio disponible",
          start: start,
          end: end,
          backgroundColor: SFC_COLOR_VERDE_CLARO,
          borderColor: SFC_COLOR_VERDE_CLARO,
          textColor: "#000000",
          extendedProps: {
            isAvailableSlot: true,
            sessionAgilizaId: session.session_agiliza_id,
            ...slot,
            ...session,
            session_date_original: slot.session_date,
            session_start_time: slot.session_start_time,
            session_end_time: slot.session_end_time,
          },
        };
      });
    },

    getWeekRange() {
      const today = new Date();

      // Fecha inicial = mañana
      const startDate = new Date(today);
      startDate.setDate(startDate.getDate() + 1);

      // Fecha final = 7 días después de la fecha inicial
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 7);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      };

      return {
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
      };
    },
    getWeekRangeFormatted() {
      const today = new Date();

      // Fecha inicial = mañana
      const startDate = new Date(today);
      startDate.setDate(startDate.getDate() + 1);

      // Fecha final = 7 días después de la fecha inicial
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 7);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${day}/${month}/${year}`;
      };

      return {
        start_date: formatDate(startDate),
        end_date: formatDate(endDate),
      };
    },
    closeModal() {
      this.isModalVisible = false;
      this.selectedSessionData = {};
    },
    handleAccessSession() {
      if (this.selectedSessionData && this.selectedSessionData.session_link) {
        window.open(this.selectedSessionData.session_link, "_blank");
      }
    },
    async handleRescheduleSession() {
      try {
        const response =
          await complaintsAgilizaServicesImplementation.rescheduleSessionAgiliza(
            this.selectedSessionData.session_agiliza_id,
          );

        if (response.isSuccess) {
          this.showToast("info", response.data.message);
        } else {
          let errorMsg = ErrorMessaje.generalError;
          if (response.data && response.data.message) {
            errorMsg = response.data.message;
          }
          this.showToast("error", errorMsg);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.calendarReady = false;
        this.selectedSessionId = null;
        this.availableSlotEvents = [];
        this.showAvailableSlotsText = false;
        this.availableSlotsText = "";
        this.closeModal();
        this.$emit("refresh");
        setTimeout(() => {
          this.calendarReady = true;
        }, 500);
      }
    },
    async handleScheduleSession(sessionLink) {
      const data = {
        session_date: this.selectedSessionData.session_date_original,
        session_start_time: this.selectedSessionData.session_start_time,
        session_end_time: this.selectedSessionData.session_end_time,
        session_link: sessionLink,
      };

      try {
        const response =
          await complaintsAgilizaServicesImplementation.scheduleSessionAgiliza(
            this.selectedSessionData.session_agiliza_id,
            data,
          );

        if (response.isSuccess) {
          this.showToast("info", response.data.message);
        } else {
          let errorMsg = ErrorMessaje.generalError;
          if (response.data && response.data.status_code === 409) {
            errorMsg =
              "El espacio seleccionado ya no se encuentra disponible. Por favor, elige otro horario e intenta realizar el agendamiento nuevamente.";
          }
          this.showToast("error", errorMsg);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.calendarReady = false;
        this.selectedSessionId = null;
        this.availableSlotEvents = [];
        this.showAvailableSlotsText = false;
        this.availableSlotsText = "";
        this.closeModal();
        this.$emit("refresh");
        setTimeout(() => {
          this.calendarReady = true;
        }, 500);
      }
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    handleExternalSelection(session) {
      this.$nextTick(() => {
        let uniqueKey = null;
        let foundSession = null;

        // Try to find in pendingToSchedule
        const pendingIndex = this.pendingToSchedule.findIndex(
          (s) => String(s.codigo_queja) === String(session.codigo_queja),
        );

        if (pendingIndex !== -1) {
          uniqueKey = "pending-" + pendingIndex;
          foundSession = this.pendingToSchedule[pendingIndex];
        } else {
          // Try to find in pendingToReschedule
          const rescheduleIndex = this.pendingToReschedule.findIndex(
            (s) =>
              String(s.id) === String(session.id) ||
              String(s.codigo_queja) === String(session.codigo_queja),
          );
          if (rescheduleIndex !== -1) {
            uniqueKey = "reschedule-" + rescheduleIndex;
            foundSession = this.pendingToReschedule[rescheduleIndex];
          }
        }

        if (uniqueKey && foundSession) {
          // Ensure we don't toggle off if it's already selected
          if (this.selectedSessionId !== uniqueKey) {
            this.handleSessionClick(uniqueKey, foundSession);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
:deep(.fc) {
  max-width: 100%;
  margin: 0 auto;
}

:deep(.fc-view-harness) {
  min-height: 500px;
}

:deep(.fc-scroller) {
  height: auto !important;
}

::v-deep .fc-button.fc-prev-button,
::v-deep .fc-button.fc-next-button {
  font-size: 1.2em !important;
  font-weight: 900 !important;
}

.calendar-main-container {
  height: auto;
}

.calendar-row {
  display: grid !important;
  grid-template-columns: 100%;
  gap: 1rem;
  width: 100%;
}

@media (min-width: 1024px) {
  .calendar-row {
    grid-template-columns: minmax(0, 1fr) 260px;
    align-items: stretch;
  }
}

@media (min-width: 1440px) {
  .calendar-row {
    grid-template-columns: minmax(0, 1fr) 320px;
  }
}

.calendar-col {
  width: 100%;
  min-height: 500px;
  overflow: hidden;
}

@media (min-width: 1024px) {
  .calendar-col {
    grid-column: 1;
  }
}

.calendar-content {
  width: 100%;
  height: auto;
}

.sidebar-col {
  width: 100%;
  min-height: 500px;
  position: relative;
}

@media (min-width: 1024px) {
  .sidebar-col {
    grid-column: 2;
    height: auto;
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.sidebar-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

@media (max-width: 1023px) {
  .sidebar-scroll {
    position: relative;
    max-height: 400px;
  }
}

.custom-panel {
  background: transparent !important;
  border: none !important;
}

:deep(.ant-collapse-header) {
  font-weight: bold !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  font-size: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 8px !important;
}

:deep(.ant-collapse-content-box) {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.session-card {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s;
}

.session-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-color: #d1d5db;
}

.selected-card {
  background-color: #e4f4ed !important;
  border-color: #e4f4ed !important;
}

:deep(.ant-card-body) {
  padding: 12px !important;
}

/* Scrollbar personalizado para el panel lateral (Oculto según requerimiento) */
.sidebar-scroll::-webkit-scrollbar {
  display: none;
}

.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding: 12px 16px;
  padding-right: 20px;
}
</style>
